export default __webpack_public_path__ + "ca86dfea1dc154f31b271d9443df7077.svg";